var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGnosis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.044 332.701c14.204 0 27.316-4.733 37.879-12.925l-86.685-86.654c-8.195 10.377-12.93 23.484-12.93 37.866-.182 34.042 27.499 61.713 61.736 61.713Zm257.869-61.896c0-14.199-4.735-27.306-12.93-37.865l-86.685 86.653c10.381 8.192 23.493 12.925 37.88 12.925 34.054.182 61.735-27.488 61.735-61.713Z",
    fill: "#04795B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m503.62 176.689-38.426 38.412c12.748 15.291 20.397 34.588 20.397 56.07 0 48.241-39.154 87.381-87.414 87.381-21.307 0-40.793-7.646-56.09-20.389l-42.068 42.052-42.068-42.052c-15.297 12.743-34.601 20.389-56.09 20.389-48.26 0-87.414-39.14-87.414-87.381 0-21.3 7.649-40.779 20.397-56.07l-19.668-19.661-18.758-18.751C74.565 212.734 62 254.787 62 299.934c0 131.436 106.535 237.75 237.838 237.75 131.302 0 237.837-106.496 237.837-237.75.365-45.329-12.201-87.382-34.054-123.245Z",
    fill: "#04795B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M472.114 135.728C428.954 90.399 367.764 62 300.019 62c-67.746 0-128.753 28.399-172.095 73.728a286.174 286.174 0 0 0-16.755 19.479l188.668 188.598 188.667-188.78c-4.735-6.554-10.38-13.289-16.39-19.297Zm-172.095-42.78c55.726 0 107.446 21.481 146.236 60.621L300.019 299.751 153.783 153.569c38.972-39.14 90.51-60.621 146.236-60.621Z",
    fill: "#04795B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnosis);
export default __webpack_public_path__ + "static/media/gnosis.755db048b13360966da9c32eee0ea9d0.svg";
export { ForwardRef as ReactComponent };